import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {

      awbnumber: '',
      description: '',
      myStr: '',
      zoneid: 0,

      current_hub_name: '',
      origin_hub_name: '',
      destination_hub_name: '',
      octroi_MRP: '',


      newhubList: [],
      shipmenarr: [],
      show: false,
      editshowtable: false,
      username: '',
      alldata: ''
    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
  },
  methods: {

    // zone api
    getZoneFromcurrenthub(zonehubid) {
      this.show = true;
      let zonehubarr = [];
      zonehubarr.push(zonehubid);
      this.input = ({
        hubids: zonehubarr
      })
      axios({
        method: 'post',
        url: apiUrl.api_url + 'gethubzoneIdsbyhubId',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.show = false;

        this.zoneid = result.data.data;
        this.gethubList(this.zoneid);

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    // hub  api
    gethubList(zoneid) {
      this.input = ({
        id: zoneid
      })
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getHubList',
        data: { id: this.zoneid },
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        let finalHubData = []
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName
          })
        })
        this.editshowtable = false;
        this.newhubList = finalHubData;
        for (let j = 0; j < this.newhubList.length; j++) {
          if (this.newhubList[j]["id"] == this.shipmenarr[0]["currenthubid"]) {
            this.current_hub_name = this.newhubList[j]["label"];
          }
        }
        for (let k = 0; k < this.newhubList.length; k++) {
          if (this.newhubList[k]["id"] == this.shipmenarr[0]["originhubid"]) {

            this.origin_hub_name = this.newhubList[k]["label"];
          }
        }
        for (let z = 0; z < this.newhubList.length; z++) {
          if (this.newhubList[z]["id"] == this.shipmenarr[0]["finaldestinationid"]) {

            this.destination_hub_name = this.newhubList[z]["label"];
          }
        }

        this.editshowtable = true;
      },
        error => {
          console.error(error)
        })
    },

    getshippingidDetails() {
      this.description = '';
      this.destination_hub_name = '';
      this.current_hub_name = '',
        this.origin_hub_name = '',
        this.octroi_MRP = ''
      this.input = ({
        shippingid: this.awbnumber

      })

      axios({
        method: 'post',
        url: apiUrl.api_url + 'searchDisposeMarkBy',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.alldata = result.data;
        if (result.data.code == 200) {
          this.shipmenarr = result.data.data
          let zonehubid = this.shipmenarr[0]["currenthubid"];
          this.getZoneFromcurrenthub(zonehubid);
          this.octroi_MRP = this.shipmenarr[0]["netvalue"];
        }
        else {
          this.$alertify.error(result.data.message)
        }


      })
    },

    updateDispute() {
      var netpayment, rackId, ucgcode, stdshipmentId, netpayment, actioncode;
      if (!this.awbnumber) {
        this.$alertify.error("Please Select ShippingId ");
      }
      else if (!this.description) {
        this.$alertify.error("Please Fill Description");
      }
      else {
        if(this.alldata.data1[0] !== undefined){
          if(this.alldata.data1[0].ucgstatuscode !== null && this.alldata.data1[0].ucgstatuscode !== undefined){
            ucgcode = this.alldata.data1[0].ucgstatuscode;
          }else{
            ucgcode = 0;
          }
        }else{
          ucgcode = 0;
        }

        if (this.alldata.data1[0] !== undefined) {
          if(this.alldata.data1[0].rackid !== null && this.alldata.data1[0].rackid !== undefined){
            rackId = this.alldata.data1[0].rackid;
          }else{
            rackId = "0";
          }
        }else{
          rackId = "0";
        }

        if (this.alldata.data1[0] !== undefined) {
          if(this.alldata.data1[0].stdshipmentid !== null && this.alldata.data1[0].stdshipmentid !== undefined){
            stdshipmentId = this.alldata.data1[0].stdshipmentid;
          }else{
            stdshipmentId = 1;
          }
        }else{
          if(this.alldata.data[0] !== undefined){
            stdshipmentId = this.alldata.data[0].stdshipmentid;
          }else{
            stdshipmentId = 1;
          }
        }

        if (this.alldata.data1[0] !== undefined) {
          if(this.alldata.data1[0].netpaymentreceived !== null && this.alldata.data1[0].netpaymentreceived !== undefined){
            netpayment = this.alldata.data1[0].netpaymentreceived;
          }else{
            netpayment = 0;
          }
        }else{
          if(this.alldata.data[0] !== undefined){
            netpayment = this.alldata.data[0].netpaymentreceived;
          }else{
            netpayment = 0;
          }
        }
        if(this.alldata.data[0] !== undefined){
          if(!this.alldata.data[0].actionstatuscode && this.alldata.data[0].actionstatuscode !== null){
            actioncode = this.alldata.data[0].actionstatuscode;
          }else{
          actioncode = 0;
          }
        }else{
          actioncode = 0;
        }

        var vstatusid = actioncode.toString()
        this.input = ({
          ShippingID: this.awbnumber,
          Description: this.description,
          UCGStatusCode: ucgcode,
          rackID: rackId,
          netPaymentReceived: netpayment,
          LastModifiedBy: this.username,
          isDisposeAtHub: true,
          STDShipmentId: stdshipmentId,
        });
        try{

          axios({
            method: 'post',
            url: apiUrl.api_url + 'updateDisposemarkbyUCGInventory',
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + this.myStr
            }
          }).then(result => {
              if (result.data.code == 204) {
                this.$alertify.success(result.data.message);

              }
              else {
                this.$alertify.error(result.data.message);

              }
              this.awbnumber = '';
              this.description = '';
              this.destination_hub_name = '';
              this.current_hub_name = '',
              this.origin_hub_name = '',
              this.octroi_MRP = ''

            })
          }catch(Exception){
            console.log(Exception);
          }
        }//else
    },

    resetForm() {
      this.awbnumber = '';
      this.description = '';
      this.destination_hub_name = '';
      this.current_hub_name = '',
        this.origin_hub_name = '',
        this.octroi_MRP = ''
      this.isLoading = false;
      this.$validator.reset(); this.errors.clear();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/DisposeBySuperAdmin/DisposeBySuperAdmin.component.js